// Browser-storage keys Bosko no longer writes. The Home and Daily Readings
// pages once cached their props here and nothing read them back, so they only
// kept a copy of the profile (name, faith tradition, places of worship) on the
// device. Logout already removes them (clearUser); this sweep reaches devices
// that never sign out. The privacy policy lists what is still stored.
// Review timestamp/count were replaced by an anonymous session-only marker.
export const RETIRED_KEYS = [
  'cache:home',
  'cache:daily-readings',
  'bosko:lastReviewPromptAt',
  'bosko:reviewPromptCount',
];

export function removeRetiredStorage() {
  try {
    RETIRED_KEYS.forEach((key) => localStorage.removeItem(key));
  } catch {
    // Storage blocked (private mode, sandboxed WebView): nothing to remove.
  }
}
